import { memo } from 'react';
import PropTypes from 'prop-types';

import Draggable from 'react-draggable';

const DraggablePanel = ({ axis = "both", bounds = undefined, children, draggingClassName, handle, isDragging = false, nodeRef, onStart = undefined, onStop = undefined, position, scale = 1 }) => (
  <Draggable
      axis={axis}
      bounds={bounds}
      defaultClassNameDragging={draggingClassName}
      defaultPosition={position}
      handle={handle}
      nodeRef={nodeRef}
      onStart={onStart}
      onStop={onStop}
      position={isDragging ? undefined : position}
      scale={scale}
  >
    {children}
  </Draggable>
)

DraggablePanel.propTypes = {
  axis: PropTypes.oneOf(["both", "x", "y", "none"]),
  bounds: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      bottom: PropTypes.number,
      left: PropTypes.number,
      right: PropTypes.number,
      top: PropTypes.number
    })
  ]),
  children: PropTypes.node.isRequired,
  draggingClassName: PropTypes.string,
  handle: PropTypes.string.isRequired,
  isDragging: PropTypes.bool,
  nodeRef: PropTypes.shape({ current: PropTypes.any }).isRequired,
  onStart: PropTypes.func,
  onStop: PropTypes.func,
  position: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }).isRequired,
  scale: PropTypes.number
}

export default memo(DraggablePanel)
